import { type Book } from "@/schema"

import { ApiContext, apiContextFetch } from "@/hooks/api/base"

export interface BooksResponse {
  books: Book[]
}

export function fetchBooks(context: ApiContext) {
  return apiContextFetch<BooksResponse>(context, `books`)
}

export function fetchBook(context: ApiContext, id: string) {
  return apiContextFetch<Book>(context, `books/${id}`)
}

export interface CreateBookPayload {
  name: string
  principal_id: string
}

export function createBook(context: ApiContext, data: CreateBookPayload) {
  return apiContextFetch<Book>(context, "books", {
    method: "POST",
    body: JSON.stringify({ book: data }),
  })
}

export type UpdateBookPayload = Partial<Book> & {
  iconImageFile?: File
  remove_icon_image?: boolean
}

export function updateBook(context: ApiContext, bookId: string, data: UpdateBookPayload) {
  const { iconImageFile, ...bookUpdates } = data

  if (iconImageFile) {
    const formData = new FormData()
    formData.append("book[icon_image]", iconImageFile)

    Object.entries(bookUpdates).forEach(([key, value]) => {
      if (value !== undefined && value !== null) formData.append(`book[${key}]`, value.toString())
    })

    return apiContextFetch<Book>(context, `books/${bookId}`, {
      method: "PUT",
      body: formData,
    })
  }

  return apiContextFetch<Book>(context, `books/${bookId}`, {
    method: "PUT",
    body: JSON.stringify({ book: bookUpdates }),
  })
}

export function regenerateBookVoiceProfile(context: ApiContext, bookId: string) {
  return apiContextFetch<{ ai_generating_profile_at: string }>(context, `books/${bookId}/regenerate_voice_profile`, {
    method: "POST",
  })
}
